import { Displays } from 'game/constants/layout';
import { Layout } from 'game/LayoutManager';
import { ATLAS_REGISTRY, AtlasName } from 'game/assets/generated';
import { BaseAtlas } from 'game/assets/generated/BaseAtlas';

function formatBackgroundName(name: string): string {
    return name
        .split('_')
        .map((part, index) => {
            // Первая часть остается как есть (может быть цифрой)
            if (index === 0) return part;
            // Остальные части - первая буква заглавная
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        })
        .join('');
}


export function getBackgroundAtlasClass(backgroundName: string, folder?: string): typeof BaseAtlas | null {
    if (!folder) {
        switch (Layout.getDisplay()) {
            case Displays.MOBILE:
                folder = 'Mobile';
                break;
            case Displays.TABLET:
                folder = 'Tablet';
                break;
            default:
                folder = 'Desktop';
                break;
        }
    } else {
        folder = folder.charAt(0).toUpperCase() + folder.slice(1).toLowerCase();
    }
    
    const formattedName = formatBackgroundName(backgroundName);
    const atlasClassName = `${folder}${formattedName}` as keyof typeof AtlasName;
    
    if (AtlasName[atlasClassName]) {
        const atlasClass = ATLAS_REGISTRY[AtlasName[atlasClassName]];
        return atlasClass || null;
    }
    
    console.warn(`Background atlas not found: ${atlasClassName}`);
    return null;
}


export async function loadBackgroundAtlas(backgroundName: string, folder?: string): Promise<void> {
    const atlasClass = getBackgroundAtlasClass(backgroundName, folder);
    
    if (!atlasClass) {
        throw new Error(`Background atlas not found for: ${backgroundName}`);
    }
    
    if (typeof (atlasClass as any).load === 'function') {
        await (atlasClass as any).load();
    }
}

export function unloadBackgroundAtlas(backgroundName: string, folder?: string): void {
    const atlasClass = getBackgroundAtlasClass(backgroundName, folder);
    
    if (atlasClass && typeof (atlasClass as any).unload === 'function') {
        (atlasClass as any).unload();
    }
}

